module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_zoyi.73ed5fb67c94f98d02b16a909b944f4b.png";